import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
// import Grow from '@mui/material/Grow';
// import Popper from '@mui/material/Popper';
// import MenuItem from '@mui/material/MenuItem';
// import MenuList from '@mui/material/MenuList';
// import ClickAwayListener from '@mui/material/ClickAwayListener';

// import MenuIcon from '@mui/icons-material/Menu';
import ClearIcon from '@mui/icons-material/Clear';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';

// import PopupMenu from './popupmenu';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
        height: '36.5px',
    },
    input: {
        paddingLeft: theme.spacing(1),
        flex: 1,
    },
    listItem: {
        color: theme.palette.text.hint,
        fontSize: 12,
    },
    iconButton: {
        padding: 8,
    },
    divider: {
        height: 28,
        margin: '0 4px',
    },
}));

const SearchBar = (props) => {
    const classes = useStyles();

    const [init, setInit] = useState();
    const [value, setValue] = useState(props.value || '');
    const [outgoing, setOutgoing] = useState({});
    // const [savedSearches, setSavedSearches] = useState(props.searchservice.getSavedSearches());

    // const [inputPopupOpen, setInputPopupOpen] = useState(false);

    const handleSearchChange = event => {
        setValue(event.target.value);
        if (props.immediate) {
            setOutgoing({ search: event.target.value });
        }
    };

    const handleOnSearch = event => {
        // Stops a weird bug where the page refreshes, I think?
        // I can't tell where it's happening from but this seemed to quell the issue for now
        event.preventDefault();
        event.stopPropagation();

        setOutgoing({ search: value });
    };

    const handleClearSearch = () => {
        setValue('');
        setOutgoing({ search: '' });
    };

    // saved filters (history) handlers
    // const handleSearchHistorySelection = s => {
    //     setValue(s);
    //     setOutgoing({ search: s });
    // };

    const filterUnmodified = () => {

    };

    useEffect(() => {
        // skip initial load
        if (!init) {
            setInit(true);
            return;
        }
        props.onSearch && props.onSearch(outgoing);
        // props.searchService.saveSearch(outgoing);
        // setSavedSearches(props.searchService.getSavedSearches());
    }, [outgoing]);

    return (
        <Paper component="form" className={classes.root} style={props.style || {}}>
            {/* TODO: saved searches */}
            {/* <PopupMenu
                items={savedSearches}
                onSelect={handleSearchHistorySelection}
                icon={<MenuIcon/>}
                placement={'bottom-end'}
                action={{ icon: <ClearIcon />, fn: handleClearSearch }}/> */}

            {/* text search input */}
            {/* <Divider className={classes.divider} orientation="vertical" /> */}
            <InputBase
                className={classes.input}
                value={value}
                
                onChange={handleSearchChange}
                placeholder={props.searchservice.searchPlaceholder}
                inputProps={{ 'aria-label': props.searchservice.searchPlaceholder, spellCheck: false , maxLength: props.maxLength}}/>

            {/* clear button */}
            <Divider className={classes.divider} orientation="vertical" />
            <IconButton
                className={classes.iconButton}
                color="default"
                disabled={!value}
                aria-label="clear"
                onClick={handleClearSearch}
                size="large">
                <ClearIcon />
            </IconButton>

            {/* search button */}
            <IconButton
                className={classes.iconButton}
                disabled={!value && filterUnmodified()}
                type="submit"
                aria-label="search"
                onClick={handleOnSearch}
                size="large">
                <SearchIcon />
            </IconButton>

            {/* reset button */}
            {props.reset && <IconButton
                title="reset page"
                className={classes.iconButton}
                color="default"
                aria-label="clear"
                onClick={() => {
                    if (props.clearSearchOnReset) {
                        handleClearSearch();
                    }
                    setTimeout(() => {
                        props.reset();
                    });
                }}
                size="large">
                <SettingsBackupRestoreIcon />
            </IconButton>}

        </Paper>
    );
};

SearchBar.propTypes = {
    onSearch: PropTypes.func.isRequired,
    value: PropTypes.string,
    searchservice: PropTypes.object.isRequired,
    classes: PropTypes.object,
    immediate: PropTypes.bool,
    style: PropTypes.object,
    reset: PropTypes.func,
    clearSearchOnReset: PropTypes.bool,
};

export default SearchBar;
